import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Aktif kategoriler + (pasifse) ürünün mevcut kategorisi; boş = Kategorisiz.
export default function CategorySelect({ value, original, onChange, testid = "product-category-select" }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/product-categories").then(({ data }) => setItems(data.items)).catch(() => setItems([])); }, []);
  const opts = items.filter((c) => c.active || c.name === original);
  return (
    <select value={value || ""} onChange={(e) => onChange(e.target.value)} className="w-full h-9 px-2 rounded-md border border-slate-300 text-sm bg-white" data-testid={testid}>
      <option value="">Kategorisiz</option>
      {opts.map((c) => <option key={c.id} value={c.name}>{c.name}{c.active ? "" : " (pasif)"}</option>)}
      {value && !items.some((c) => c.name === value) && <option value={value}>{value}</option>}
    </select>
  );
}
